import type { AuthUser } from "../../auth/auth";
import type { Room } from "../../lib/rooms";
import { RoomDock } from "./RoomDock";

export type DockRoom = Pick<Room, "name" | "hasPassword" | "maxParticipants">;

export function StageControls({
  room,
  user,
  onSignOut,
}: {
  room: DockRoom;
  user: AuthUser | null;
  onSignOut: () => void;
}) {
  return (
    <footer className="stage-controls relative z-30 flex items-center justify-center bg-black px-2 pt-4 pb-3">
      <RoomDock
        roomName={room.name}
        hasPasscode={room.hasPassword}
        maxParticipants={room.maxParticipants ?? undefined}
        user={user}
        onSignOut={onSignOut}
      />
    </footer>
  );
}
